import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { MatTableModule } from "@angular/material/table";
import { PriceModule } from "libraries/component/price/price.module";
import { CostGridBlockCostCurrencyComponent } from "./cost-grid-block-cost-currency.component";
import { SimpleSelectModule } from "libraries/module/formbuilder/fields/simple-select/simple-select.module";
import { CostFormGeneratorModule } from "../../../../../services/cost-form-generator/cost-form-generator.module";
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        PriceModule,
        SimpleSelectModule,
        CostFormGeneratorModule,
        MultiselectModule,
    ],
    exports: [
        CostGridBlockCostCurrencyComponent
    ],
    declarations: [
        CostGridBlockCostCurrencyComponent
    ],
    providers: [],
})
export class CostGridBlockCostCurrencyModule {
}
